export default "__VITE_ASSET__DkitayFe__"